export default __webpack_public_path__ + "static/media/i.dff5f8cf.svg";